<template>
  <v-main>
    <v-card color="green lighten-5 fill-height">
      <v-card-actions>
        <v-subheader>{{$t('rec_types.'+item.recType)}}</v-subheader>
        <v-spacer></v-spacer>
        <v-btn icon @click="close" color="error">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form ref="form" :lazy-validation="true">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="item.name"
                :label="$t('field.name')+'*'"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                clearable
                shaped
                outlined
                :rules="[v => !!v || v!=null&&v.length<=64 || $t('error.length')]"
                counter="64"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <i18n path="field.valid" />
              <DatePicker
                format="YYYY-MM-DD"
                type="date"
                :placeholder="$t('label.placeholder')"
                v-model="item.validExt"
                :rules="validRules"
                :lang="$i18n.locale"
                :label="$t('field.valid')"
                input-class="idcs-data-pick"
                class="idcs-picker-wrap ml-2"
              ></DatePicker>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="item.bin"
                :rules="binRules"
                prepend-icon="mdi-magnify"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                clearable
                shaped
                outlined
                counter="64"
                @click:prepend="findCard"
                :label="$t('field.bin')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                :items="$t('recStatus')"
                :label="$t('field.status')"
                v-model="item.status"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                shaped
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                :items="$t('admin.pinFlags')"
                :label="$t('field.pinFlag')"
                v-model="item.pinFlag"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                shaped
                outlined
              ></v-select>
              <!-- <v-text-field
                v-model="item.pinFlag"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                shaped
                outlined
                type="number"
                :label="$t('field.pinFlag')"
              ></v-text-field>-->
            </v-col>
            <v-col cols="6" md="4">
              <v-checkbox v-model="item.debetIn" :label="$t('field.debetIn')"></v-checkbox>
            </v-col>
            <v-col cols="6" md="4">
              <v-checkbox v-model="item.justTrans" :label="$t('field.justTrans')"></v-checkbox>
            </v-col>
            <v-col cols="6" md="4">
              <v-checkbox v-model="item.needOperNr" :label="$t('field.needOperNr')"></v-checkbox>
            </v-col>
            <v-col cols="12">
              <v-expansion-panels>
                <v-expansion-panel class="transparent">
                  <v-expansion-panel-header>
                    <v-text-field class="ml-6" v-model="item.extset" :label="$t('field.extset')"></v-text-field>
                    <v-chip
                      v-for="i in 10"
                      :key="i"
                      class="mr-2"
                      :color="isbit(10-i+1)?'primary':'light-grey'"
                    >
                      <v-icon left>{{'mdi-numeric-'+(10-i+1)+'-circle'}}</v-icon>
                      {{isbit(10-i+1)}}
                    </v-chip>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-toolbar class="transparent">
                      <v-btn-toggle v-model="posmenu" multiple>
                        <v-btn>
                          <v-icon>mdi-keyboard-f1</v-icon>
                        </v-btn>
                        <v-btn>
                          <v-icon>mdi-keyboard-f2</v-icon>
                        </v-btn>
                        <v-btn>
                          <v-icon>mdi-keyboard-f3</v-icon>
                        </v-btn>
                        <v-btn>
                          <v-icon>mdi-keyboard-f4</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      <v-divider vertical class="mx-1"></v-divider>
                      <v-btn-toggle v-model="poslang" mandatory>
                        <v-btn>
                          <country-flag country="lv" size="normal" />
                        </v-btn>
                        <v-btn>
                          <country-flag country="gb" size="normal" />
                        </v-btn>
                      </v-btn-toggle>
                      <v-divider vertical class="mx-1"></v-divider>
                      <v-overflow-btn :items="f1texts" v-model="f1text" hide-details class="pa-0"></v-overflow-btn>
                      <v-divider vertical class="mx-1"></v-divider>
                      <v-overflow-btn :items="f2texts" v-model="f2text" hide-details class="pa-0"></v-overflow-btn>
                      <v-divider vertical class="mx-1"></v-divider>
                      <v-overflow-btn :items="mobfaces" v-model="mobface" hide-details class="pa-0"></v-overflow-btn>
                    </v-toolbar>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="item.checkSumFormula"
                background-color="yellow lighten-5"
                color="black"
                :placeholder="$t('label.placeholder')"
                clearable
                shaped
                outlined
                :rules="[v => v==null || v.length<=512 || $t('error.lenght')]"
                counter="512"
                :label="$t('field.checkSumFormula')"
                auto-grow
              ></v-textarea>
            </v-col>
            <v-col cols="6">
              {{$t('field.created')+':'}}
              <small>{{item.created}}</small>
            </v-col>
            <v-col cols="6" class="last-modified">
              {{$t('field.modified')+':'}}
              <small>{{item.lastModified}}</small>
            </v-col>
            <v-col cols="12">
              <v-alert
                v-model="showAlert"
                border="left"
                colored-border
                type="error"
                elevation="2"
                :dismissible="true"
                transition="fade-transition"
              >{{alertMessage}}</v-alert>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="$store.getters.test('SystemRecord.d')"
          color="blue darken-1"
          text
          @click="simpleDialog=true"
        >{{$t('button.delete')}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="$store.getters.test('SystemRecord.w')"
          color="blue darken-1"
          text
          @click="save(false)"
        >{{$t('button.apply')}}</v-btn>
        <v-btn
          v-if="$store.getters.test('SystemRecord.w')"
          color="blue darken-1"
          text
          @click="save(true)"
        >{{$t('button.save')}}</v-btn>
      </v-card-actions>
    </v-card>
    <DeleteDialog v-model="simpleDialog" @click:ok="erase" />
  </v-main>
</template>
<script>
//import axios from "axios";
import app from "@/app.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
//import moment from "moment";
import DeleteDialog from "@/components/DeleteDialog.vue";
import CountryFlag from "vue-country-flag";

export default {
  components: { DatePicker, DeleteDialog, CountryFlag },
  name: "SystemEditor",
  props: {
    record: { type: Object, required: true },
    isnew: { type: Boolean },
    //bins: { type: Array },
    value: { type: Boolean },
  },
  data() {
    return {
      simpleDialog: false,
      showAlert: false,
      f1texts: [
        {
          value: 0,
          text: "Apmaksa ar Dāvanu karti",
        },
        {
          value: 1,
          text: "Pirkuma reģistrācija",
        },
        {
          value: 2,
          text: "Pay by Gift card",
        },
        {
          value: 3,
          text: "Purchase registration",
        },
      ],
      f2texts: [
        {
          value: 0,
          text: "Dāvanu kartes aktivizēšana (papildināšana)",
        },
        {
          value: 1,
          text: "Apmaksa ar Klienta karti",
        },
        {
          value: 2,
          text: "Purchase a Gift card'",
        },
        {
          value: 3,
          text: "Pay by Customer card",
        },
      ],

      mobfaces: [
        {
          value: 0,
          text: this.$t("admin.interface_type.1"),
        },
        {
          value: 1,
          text: this.$t("admin.interface_type.2"),
        },
        {
          value: 2,
          text: this.$t("admin.interface_type.3"),
        },
      ],
      alertMessage: "",
      userRules: [(v) => !!v || this.$t("error.required")],
      binRules: [(v) => !!v || this.$t("error.required")],
      validRules: [
        (v) => (!!v && this.$moment(v).afterNow()) || this.$t("error.valid"),
      ],
      item: this.record,
    };
  },
  mounted() {
    this.setDefaults();
  },
  watch: {
    record: {
      handler() {
        this.setDefaults();
      },
      deep: true,
    },
  },
  computed: {
    posmenu: {
      get() {
        let m = [];
        if (!this.item.debetIn) m.push(1);
        if ((this.item.extset & 1) > 0) m.push(0);
        if ((this.item.extset & 2) > 0) m.push(2);
        if ((this.item.extset & 4) > 0) m.push(3);
        return m;
      },
      set(v) {
        this.item.extset = this.item.extset ^ (this.item.extset & 7);
        this.item.debetIn = v.indexOf(1) == -1;
        if (v.indexOf(0) != -1) this.item.extset = this.item.extset | 1;
        if (v.indexOf(2) != -1) this.item.extset = this.item.extset | 2;
        if (v.indexOf(3) != -1) this.item.extset = this.item.extset | 4;
      },
    },
    poslang: {
      get() {
        return (this.item.extset & 8) > 0 ? 1 : 0;
      },
      set(v) {
        this.item.extset =
          v == 0
            ? this.item.extset ^ (this.item.extset & 8)
            : this.item.extset | 8;
      },
    },
    f1text: {
      get() {
        if ((this.item.extset & 48) == 48) return 3;
        else if ((this.item.extset & 32) == 32) return 2;
        else if ((this.item.extset & 16) == 16) return 1;
        return 0;
      },
      set(v) {
        this.item.extset = this.item.extset ^ (this.item.extset & 48);
        if (v == 1) this.item.extset = this.item.extset | 16;
        else if (v == 2) this.item.extset = this.item.extset | 32;
        else if (v == 3) this.item.extset = this.item.extset | 48;
      },
    },
    f2text: {
      get() {
        if ((this.item.extset & 192) == 192) return 3;
        else if ((this.item.extset & 128) == 128) return 2;
        else if ((this.item.extset & 64) == 64) return 1;
        return 0;
      },
      set(v) {
        this.item.extset = this.item.extset ^ (this.item.extset & 192);
        if (v == 1) this.item.extset = this.item.extset | 64;
        else if (v == 2) this.item.extset = this.item.extset | 128;
        else if (v == 3) this.item.extset = this.item.extset | 192;
      },
    },
    mobface: {
      get() {
        if ((this.item.extset & 512) == 512) return 2;
        else if ((this.item.extset & 256) == 256) return 1;
        return 0;
      },
      set(v) {
        this.item.extset = this.item.extset ^ (this.item.extset & 768);
        if (v == 1) this.item.extset = this.item.extset | 256;
        else if (v == 2) this.item.extset = this.item.extset | 512;
      },
    },
  },
  methods: {
    setDefaults() {
      this.item = { ...this.record };
      if (!this.item.validExt) {
        this.item.validExt = this.$moment().add(10, "year").toDate();
      }
    },
    isbit(i) {
      return this.item.extset & (1 << (i - 1)) ? 1 : 0;
    },
    findCard() {
      if (!this.$store.getters.test("cards")) return;
      this.$router.push({
        name: "cards",
        query: { pattern: this.item.bin },
      });
    },
    close() {
      this.$emit("input", false);
    },
    erase() {
      app
        .erase(this.item.id, this.item.recType)
        .then(() => {
          this.$emit("delete", this.item);
          this.close();
        })
        .catch((error) => {
          this.showAlertMessage(error);
        });
    },
    save(close) {
      if (!this.$refs.form.validate()) return;
      let newRec = this.isnew;
      if (!this.isnew && this.record.bin != this.item.bin) {
        const existsSystem = this.$store.getters["struct/systemByBin"](
          this.item.bin
        );
        if (existsSystem) {
          this.showAlertMessage(
            this.$t("error.existsbin") + ": " + existsSystem.text
          );
          return;
        }
      }
      if (this.item.fk_ == "dummy") newRec = false;
      let params = {
        status: this.item.status,
        name: this.item.name,
        bin: this.item.bin,
        extset: this.item.extset,
        pinFlag: this.item.pinFlag,
        validExt: this.$moment(this.item.validExt).format("YYYY-MM-DD"),
        checkSumFormula: this.item.checkSumFormula,
        fk: newRec ? "dummy" : null,
      };
      if (this.item.justTrans) params.justTrans = this.item.justTrans;
      if (this.item.needOperNr) params.needOperNr = this.item.needOperNr;
      if (this.item.debetIn) params.debetIn = this.item.debetIn;
      app
        .update(this.item.id, this.item.recType, params)
        .then(() => {
          if (newRec) {
            this.$emit("insert", this.item);
            this.item.fk_ = "dummy";
          } else {
            this.$emit("update", this.item);
          }
          if (close) this.close();
        })
        .catch((error) => {
          this.showAlertMessage(error);
        });
    },
    showAlertMessage(m) {
      if (m.errorMsg) {
        this.alertMessage = this.$t("error." + m.errorMsg);
      } else {
        this.alertMessage = JSON.stringify(m);
      }
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 4000);
    },
  },
};
</script>

<style scoped>
.last-modified {
  text-align: right;
}
</style>